import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import App from './pages';
import store from './core/store';
import enUS from 'antd/lib/locale/en_US';
import '@moxie/styles';

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={enUS}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);
